import React from "react";
import { Avatar, Box, IconButton, Typography } from "@mui/material";
import styled from "styled-components";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import GitHubIcon from "@mui/icons-material/GitHub";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

import { useSelector } from "react-redux";

const Container = styled(Box)`
  display: flex;
  align-items: center;
  padding: 16px;
  background: white;
  border-radius: 8px;
  margin-left: 32px;
  width: 60%;
  height: 120px;
  @media (max-width: 1300px) {
    width: 100%;
  }
  @media (max-width: 768px) {
    margin-left: 0;
    height: 90px;
    width: 100%;
  }
  @media (max-width: 400px) {
    width: 55%;
    padding: 8px;
  }
`;

const InfoBox = styled(Box)`
  margin-left: 16px;
  display: flex;
  flex-direction: column;
  @media (max-width: 768px) {
  }
  @media (max-width: 400px) {
    margin-left: 0px;
  }
`;

const Name = styled(Typography)`
  font-size: 25px;
  font-weight: bold;
  color: rgb(90, 89, 89);
  @media (max-width: 1115px) {
    font-size: 22px;
  }
  @media (max-width: 768px) {
    font-size: 13px;
  }
  @media (max-width: 400px) {
    font-size: 11px;
  }
`;

const DetailRow = styled(Box)`
  display: flex;
  align-items: center;
  gap: 75px;
  margin-top: 4px;
  font-size: 20px;
  color: #e86225;
  font-weight: 400;
  @media (max-width: 768px) {
    font-size: 11px;
    gap: 1rem;
  }
  @media (max-width: 400px) {
    font-size: 10px;
  }
`;

export default function SobreAlunoCard() {
  const profile = useSelector((state) => {
    if (state?.user?.profile?.dataValues) {
      return state.user.profile.dataValues;
    } else {
      return state.user.profile || {};
    }
  });
  const nome =
    profile?.nome_social?.length > 0 ? profile.nome_social : profile.name;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Container style={{ border: "1px solid #e86225" }}>
      {!isMobile && (
        <Avatar
          sx={{ width: 75, height: 75, bgcolor: "#e86225", marginLeft: "20px" }}
          src={profile.avatar_url || ""}
        >
          {nome?.[0] || "?"}
        </Avatar>
      )}

      <InfoBox>
        <Box display="flex" alignItems="center" gap={3}>
          <Name>{nome || "Nome do Aluno"}</Name>
          {profile.linkedin && (
            <IconButton
              size="large"
              component="a"
              href={profile.linkedin}
              target="_blank"
            >
              <LinkedInIcon viewBox="large" sx={{ color: "#f97338" }} />
            </IconButton>
          )}
        </Box>

        <DetailRow>
          <span>{profile.ocupacao || "Ocupação"}</span>
          <span>{profile.foco_carreira || "Foco da carreira"}</span>
          <span>{profile.municipio_atuacao || "Maceió - AL"}</span>
        </DetailRow>
      </InfoBox>
    </Container>
  );
}
